import { EMAIL_PREFIX } from './constant/prefix';

/**
 * 邮件链接mailto:531282971@qq.com?subject=abc转成对象{address:'xx',subject:'xx'}
 * @param mailStr
 */
export function transMailStr2Obj(mailStr: string): { address: string; subject: string } {
    let address = '';
    let subject = '';
    const start = EMAIL_PREFIX;
    if (mailStr && mailStr.indexOf(start) === 0) {
        const subIndex = mailStr.indexOf('?');
        if (subIndex > 0) {
            address = mailStr.substring(start.length, subIndex);
            subject = decodeURI(mailStr.substring(subIndex + 9));
        } else {
            address = mailStr.substring(start.length);
        }
    }
    return { address, subject };
}


/**
 * 对象转成邮件链接
 * @param mailObj
 */
export function transMailObj2Str(mailObj: { address: string; subject: string }): string {
    const { address } = mailObj;
    const { subject } = mailObj;

    let returnValue = EMAIL_PREFIX;
    if (address) {
        returnValue += address;
    }
    if (subject) {
        returnValue += `?subject=${encodeURI(subject)}`;
    }
    return returnValue;
}
